export default __webpack_public_path__ + "static/media/commonocean-rl.46209d8e.md";